import React, {Component} from "react";

import Paging from "../../../Buttons/PagingBtn/index";
import * as AdminTeacherService from "../../../../services/Teacher/AdminTeacherService";

import Moment from "moment";

class AdminAuthority extends Component {
    state = {
        curPageAuthorList: [],

        // loading
        isLoadingHide: true
    }

    constructor() {
        super();

        this.curPage = 0;
        this.totalPages = 1;
        this.searchValue = null;

        this.sortSizeList = [
            {id: 0, text: "전체 보기", value: 1000000},
            {id: 1, text: "30개씩 보기", value: 30},
            {id: 2, text: "50개씩 보기", value: 50},
        ];
        this.sortSizeValue = 30;

        this.authorList = [
            {id: 0, text: '관리자', value: 'I_BEACON'},
            {id: 1, text: '원장선생님', value: 'I_ADMIN'},
            {id: 2, text: '선생님', value: 'I_TEACHER'},
        ]

        this.getAuthorityList();
    }

    handleChange = (e) => {
        this.curPage = 0;
        this.sortSizeValue = e.target.value;
        this.getAuthorityList();
    }

    // 옵션 세팅
    setOptionSortSelectBox = () => {
        return (
            <div className="wrap-select">
                <span></span>
                <select name="sortSizeValue" value={this.sortSizeValue} onChange={this.handleChange}>
                    {this.sortSizeList.map((value, i) => {
                        return (
                            <option key={i} value={value.value}>{value.text}</option>
                        );
                    })}
                </select>
            </div>
        );
    }

    onInputValueChanged = (e) => {
        if (e.target.value == '')
            this.inputValue = null;
        this.inputValue = e.target.value
    }

    //단어로 검색
    onSearch = () => {
        this.curPage = 0;
        this.searchValue = this.inputValue;
        this.getAuthorityList();
    }

    getAuthorityList = () => {
        const pageVO = {
            page: this.curPage,
            size: this.sortSizeValue,
            direction: 'DESC',
            sortBy: 'id'
        };

        AdminTeacherService.getTeacherList(this.searchValue, pageVO).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    this.totalPages = responseData.data.totalPages;
                    this.totalElements = responseData.data.totalElements;
                    this.setState({
                        curPageAuthorList: responseData.data.content
                    });
                } else {
                    alert(responseData.data);
                }
            } else {
                console.log(response);
                alert('GET HOMEWORK ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert("SERVER ERROR");
        });
    }

    updateAuthority = (userName, identity) => {
        AdminTeacherService.updateUserAuthority(userName, identity).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    this.getAuthorityList();
                } else {
                    alert(responseData.data);
                }
            } else {
                console.log(response);
                alert('GET HOMEWORK ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert("SERVER ERROR");
        });
    }

    setPage = () => {
        const {curPageAuthorList} = this.state;
        const list = curPageAuthorList.map(
            (item, i) => (
                <tr key={i}>
                    <td>{item.id}</td>
                    <td>{item.username}</td>
                    <td>{item.name}</td>
                    <td>{item.mobileNum}</td>
                    <td>{Moment(item.createdDate).format('YYYY-MM-DD')}</td>
                    {/*edit mode 일 때, dropbox*/}
                    <td>
                        {
                            (item.editMode) ?
                                <div className="wrap-select">
                                    <select onChange={(e) => this.handleCategoryChange(e, i)}
                                            value={(item.changeIdentity != undefined) ? item.changeIdentity : item.identity}>
                                        {this.setOptionMappingValue()}
                                    </select>
                                </div> :
                                this.getAuthorValue(item.identity)
                        }
                    </td>
                    <td>
                        {
                            (item.editMode) ?
                                <a className="btn-sm deepPink" onClick={() => this.onUpdate(i)}>저장</a> :
                                <a className="btn-sm deepPink" onClick={() => this.onEditMode(i)}>수정</a>
                        }
                    </td>
                </tr>
            )
        );
        return list;
    }

    handleCategoryChange = (e, index) => {
        const {curPageAuthorList} = this.state;
        curPageAuthorList[index].changeIdentity = e.target.value;
        this.setState({curPageAuthorList: curPageAuthorList});
    }

    setOptionMappingValue = (category) => {
        return this.authorList.map((author, i) => {
            return <option key={i} value={author.value}>{author.text}</option>
        });
    }

    getAuthorValue = (author) => {
        if (author === 'I_TEACHER')
            return '선생님';
        else if (author === 'I_ADMIN')
            return '원장선생님';
        else
            return '관리자';
    }

    onEditMode = (index) => {
        const {curPageAuthorList} = this.state;
        curPageAuthorList[index].editMode = true;

        this.setState({curPageAuthorList: curPageAuthorList});
    }

    onUpdate = (index) => {
        const {curPageAuthorList} = this.state;
        curPageAuthorList[index].editMode = false;

        this.setState({curPageAuthorList: curPageAuthorList});

        // author update api 연동
        if (curPageAuthorList[index].changeIdentity != undefined && curPageAuthorList[index].changeIdentity != curPageAuthorList[index].identity)
            this.updateAuthority(curPageAuthorList[index].username, curPageAuthorList[index].changeIdentity);
    }

    onUpdatePage = (page) => {
        this.curPage = page;
        this.getAuthorityList();
    }

    render() {
        return (
            <div className="wrap-rCon">
                <div className="wrap-top">
                    <div className="box-rfix">
                        {this.setOptionSortSelectBox()}
                        <div className="wrap-search">
                            <input className="ip-basic" type="text" placeholder="이름 검색"
                                   onChange={this.onInputValueChanged}/>
                            <a className="btn-sm yellow" onClick={() => this.onSearch()}>검색</a>
                        </div>
                    </div>
                </div>

                <div className="tb-scroll">
                    <table className="tb-basic">
                        <colgroup>
                            <col width="10%"/>
                            <col width="15%"/>
                            <col width="15%"/>
                            <col width="15%"/>
                            <col width="15%"/>
                            <col width="20%"/>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>-</th>
                            <th>아이디</th>
                            <th>이름</th>
                            <th>전화번호</th>
                            <th>가입일</th>
                            <th>권한</th>
                            <th>수정</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.setPage()}
                        </tbody>
                    </table>
                </div>
                <Paging currentPage={this.curPage} totalPages={this.totalPages} onUpdatePage={this.onUpdatePage}/>
            </div>
        );
    }
}

export default AdminAuthority;


// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminSystem/AdminAuthority.js